module.exports = __webpack_public_path__ + "img/bespoke70_10.fd065c34.jpg";